import { Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { ConfirmPopup } from '~/commonComponents';

interface IHireCandidateConfirmationPopupProps {
  isLoading: boolean;
  professionalName: string;
  onClose: () => void;
  onConfirm: () => void;
}

export const HireCandidateConfirmationPopup = ({
  isLoading,
  professionalName,
  onClose,
  onConfirm,
}: IHireCandidateConfirmationPopupProps) => (
  // @ts-expect-error - ConfirmPopup still written in JavaScript
  <ConfirmPopup
    title="Mark Candidate as Hired"
    description={
      <Typography as="span" color={colors.neutral[500]}>
        You're about to mark{' '}
        <Typography as="span" bold color={colors.neutral[500]}>
          {professionalName}
        </Typography>{' '}
        as Hired for this
        <br />
        position. A confirmation message will be sent to the
        <br />
        candidate. This job will remain open for additional
        <br />
        applicants until its status is set to Closed.
      </Typography>
    }
    descriptionStyle={{ width: '100%', marginBottom: 38 }}
    modalStyle={{ width: 560 }}
    leftButtonAction={onClose}
    leftButtonDisabled={isLoading}
    leftButtonText="Go Back"
    rightButtonAction={onConfirm}
    rightButtonLoading={isLoading}
    rightButtonText="Confirm"
  />
);
